<header class="main-header">
  <div class="container main-header-content">
    <a
      routerLink="/"
      class="nav-brand"
    >blink</a>
  </div>
</header>
